import { coreCatalogItemApi } from '../api';

export const { useGetCatalogItemByClientIdQuery } = coreCatalogItemApi;
